export enum CustomPropertyEntityTypeEnum {
  case = 'case',
  company = 'company',
  individual = 'individual',
}
